import React from 'react';

import {
    Table,
    TableHeader,
    DataTableCell,
    TableCell,
    TableBody
} from '@david.kucsai/react-pdf-table';

import {
    Document,
    Page,
    Text,
    View,
    usePDF
} from '@react-pdf/renderer';

import { chunk } from 'lodash';

import defaultStyles from './defaultStyles';

import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';


const OurTableCell = props => {

    const { style, text, ...rest } = props;

    const finalStyle = {
        ...defaultStyles.tableHeader,
        ...style
    };

    return (
        <TableCell { ...rest } style={finalStyle}>{ text }</TableCell>
    );
};

const OurDataCell = props => {

    const {
        style,
        data: row,
        columnKey
    } = props;

    const render = () => {

        if (!row[columnKey]) {

            return null;
        }

        const {
            // string | string[]
            text,
            ...styleOverride
        } = row[columnKey];


        const finalStyle = {
            ...defaultStyles.tableCell,
            ...style,
            ...styleOverride
        };

        let value;

        if (Array.isArray(text)) {

            value = text.map(text => <Text key={text}>{ text }</Text>);
        }
        else {

            value = <Text>{ text }</Text>;
        }


        return (
            <View style={ finalStyle }>
                {value}
            </View>
        );
    };

    //color only the two first columns
    let color = 'white';
    if (columnKey === 'bldg_unit' || columnKey === 'resident_name'){
        color = row.color.backgroundColor;
    }

    const finalStyle = {
        ...defaultStyles.tableCell,
        ...style,
        backgroundColor: color
    };

    return (
        <DataTableCell style={finalStyle} getContent={render} />
    );

};

const FooterPage = () => (
    <div>
        <div>
            <br/><br/>
        </div>
        <div>
            <Text
                style={defaultStyles.pageNumbers}
                render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`
                }
                fixed
            />
        </div>
    </div>
);


export const TablePage = props => {

    const {
        orientation,
        data,
        headers,
        HeaderPage,
        CoverPage,
        rowsPerPage,
        evenRowColor,
        oddRowColor,
        zebra
    } = props;

    const headersEntries = Object.entries(headers);

    const headersConfig = headersEntries.map(
        ([columnKey, config]) => ({
            style: {
                ...(config.style || {}),
                ...(config.headerStyle || {})
            },
            text: config.columnName || columnKey
        })
    );

    const dataConfig = headersEntries.map(
        ([columnKey, config]) => ({
            style: {
                ...(config.style || {}),
                ...(config.columnStyle || {})
            },
            columnKey
        })
    );

    // Validate that all headers are set
    data.forEach(d => {

        headersEntries.forEach(([key]) => {

            if (!d[key]) {

                throw Error(`missing key ${ key}`);
            }
        });
    });

    const chunks = chunk(data, rowsPerPage);

    return (
        <>
            { CoverPage && (
                <Page orientation={orientation}>
                    <CoverPage />
                </Page>
            )}
            {
                chunks.map((data, i) => (
                    <Page key={ i } orientation={orientation}>
                        { HeaderPage && (
                            <HeaderPage />
                        )}
                        <View style={defaultStyles.table}>
                            <Table
                                data={data}
                                oddRowColor={oddRowColor}
                                evenRowColor={evenRowColor}
                                zebra={zebra}
                            >
                                <TableHeader>
                                    { headersConfig.map(
                                        config => <OurTableCell key={config.text} {...config} />
                                    )}
                                </TableHeader>
                                <TableBody>
                                    { dataConfig.map(
                                        ({ columnKey, style }) => (
                                            <OurDataCell
                                                columnKey={columnKey}
                                                key={columnKey}
                                                style={ style }
                                            />)
                                    )}
                                </TableBody>
                            </Table>
                        </View>
                        { FooterPage && (
                            <View>
                                <FooterPage />
                            </View>
                        )}
                    </Page>
                ))
            }
        </>
    );
};

const PrintButton = props => {

    const PrintTable = <Document><TablePage { ...props } /></Document>;

    const [instance] = usePDF({ document: PrintTable });

    if (instance.loading) return <LoadingButton
        loading
        loadingPosition='start'
        startIcon={<SaveIcon />}
        variant='outlined'
        style={{
            color: '#002144',
            fontSize: '12px',
            fontFamily: 'Lato'
        }}
    >
    Loading
    </LoadingButton>;

    if (instance.error) return <div>Something went wrong: {instance.error}</div>;

    return (
        <a id='print' href={instance.url} style={{
            color: '#002144'
        }} target='_blank' rel='noreferrer'>&nbsp; Print</a>
    );
};


export default PrintButton;
